import * as React from 'react';

import URI from 'jsuri';

import courseraRedirect from 'js/lib/coursera.redirect';

import HorizontalDomainsMenu from 'bundles/program-home/components/multiprogram/HorizontalDomainsMenu';
import { useEnterprisePermittedProducts } from 'bundles/unified-common/contexts/EnterprisePermittedProductsContext';
import { useEnterpriseProductFeatures } from 'bundles/unified-common/contexts/EnterpriseProductFeaturesContext';
import { useProgram } from 'bundles/unified-common/contexts/EnterpriseProgramContext';
import { useThirdPartyOrganization } from 'bundles/unified-common/contexts/ThirdPartyOrganizationContext';

const EnterpriseDomainSelectorNotConfigurableModule = () => {
  const program = useProgram();
  const thirdPartyOrg = useThirdPartyOrganization();
  const productFeatures = useEnterpriseProductFeatures();
  const enterprisePermittedProducts = useEnterprisePermittedProducts();

  const onSelect = (href: string, topicQuery?: { query: string }) => {
    const uri = new URI(href);
    if (topicQuery) {
      uri.addQueryParam('query', topicQuery.query);
    }
    uri.addQueryParam('source', 'browse');

    courseraRedirect.setLocation(uri.toString());
  };

  if (!productFeatures?.enableRenderDomainsMenu) {
    return null;
  }

  if (!program || !thirdPartyOrg || !productFeatures) {
    return null;
  }

  return (
    <HorizontalDomainsMenu
      programId={program?.id}
      thirdPartyOrganizationId={thirdPartyOrg?.id}
      enableSkillsInSearchAndBrowse={productFeatures?.enableSkillsInSearchAndBrowse}
      onSelect={onSelect}
      isLimitedContent={enterprisePermittedProducts?.isProgramLimitedContent}
    />
  );
};

export default EnterpriseDomainSelectorNotConfigurableModule;
